import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material';

import { SeleccionAnioComponent } from './../seleccion-anio/seleccion-anio.component';
import { DFormato } from './../../../to/dformato';
import { FechasService } from './../../../utils/fechas.service';

@Component({
  selector: 'app-formatos',
  templateUrl: './formatos.component.html',
  styleUrls: ['./formatos.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [
  	FechasService
  ]
})
export class FormatosComponent implements OnInit {

	@Input('grupo') grupo: number;
	@Input('busqueda') busqueda: string;
	@Input('list') listEntrada: DFormato[];	
	@Input('imgObjetos') imgObjetos: any;
  @Output() onSelectedItem: EventEmitter<any> = new EventEmitter<any>();
  @Output() mostrarElementos: EventEmitter<any> = new EventEmitter<any>();
	
  public listSalida: DFormato[];

  constructor(
    private dialog: MatDialog,
  	private _fechaUtil: FechasService
  ) { 
  	this.listEntrada = new Array<DFormato>();
  	this.listSalida = new Array<DFormato>();
  }

  ngOnInit() {
  	setTimeout(() => {
  		this.filtrarLista()
  	}, 50);
  }

  private filtrarLista() {
  	for (let i in this.listEntrada) {
  		let item = this.listEntrada[i];
  		if (item.hasOwnProperty('ideGrupo') && item.ideGrupo === this.grupo) 
  			this.listSalida.push(item);  		
  	}

    if (!this.listSalida.length) this.mostrarElementos.emit(false);
    else {
      this.listSalida.sort((a: any, b: any) => {
        if (a['ideFormato'] < b['ideFormato']) return -1;
        else if (a['ideFormato'] > b['ideFormato']) return 1;
        else return 0;
      });
    }
  }

  public selectedItem(item: DFormato) {
    //Cuando la redirección debe ser desde el modelo y no desde los años
    if (item.redireccionar) {
      this.onSelectedItem.emit({
        modelo: item,
        anio: null,
        redireccionar: item.redireccionar
      });
    } 

    if (!item.anios) return;
    if (item.anios.length === 1)
  	  this.onSelectedItem.emit({
        modelo: item,
        anio: item.anios[0],
        redireccionar: null
      });  
    else
      this.selectYear(item);
  }

  private selectYear(modelo: DFormato) {
    //Cuando el modelo contiene años que se deben seleccionar
    let dialogRef = this.dialog.open(SeleccionAnioComponent, {
      data: { modelo: modelo }
    });
    dialogRef.afterClosed().subscribe(result => 
      this.onSelectedItem.emit({
        modelo: modelo,
        anio: result ? result : null,
        redireccionar: null
      })
    );             
  }

  /**
   * Funcion que realiza los calculos para indicar la alerta en la tarjeta
   * @param {Any} vencimiento
   * @return {String} color under of card selector
   */
  public verificarEstadoFormulario(vencimiento: any): string {
    // #e0bc0b - amarillo
    // #e05a0b - rojo
    let expiracion = new Date(vencimiento);
    let fechaActual = new Date();
    let diffDias = this._fechaUtil.obtenerDiferenciaDiasEntreDosFechas(expiracion, new Date());
    //let diffDias = expiracion.getDate() - fechaActual.getDate();
    //return "#d4d3d3";
    return (diffDias > 0 && diffDias <= 5) ? '#e0bc0b' : diffDias === 0 ? '#e05a0b' : '#ffffff';
  }

}



// WEBPACK FOOTER //
// D:/Selector Formularios UNR/ng_usuarios_no_registrados/ng_usuarios_no_registrados/src/app/resources/components/formatos/formatos.component.ts